// noinspection JSUnresolvedReference

import React, { memo } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import { Trans } from 'react-i18next'
import OfferContent from './offerContent'

const Offer = ({ giataId, operatorId, offerId, onGoToListClick }) => {
  return (
    <div className="container">
      <div className="TourOperatorDetail-Links">
        <span className={'Link'} onClick={onGoToListClick}>&lsaquo;&nbsp;
          <Trans>LINK_BACK_TO_TOUR_OPERATOR</Trans></span>
      </div>
      <OfferContent
        giataId={giataId}
        operatorId={operatorId}
        offerId={offerId}/>
    </div>
  )
}

Offer.propTypes = {
  giataId: PropTypes.number.isRequired,
  operatorId: PropTypes.number.isRequired,
  offerId: PropTypes.number.isRequired,
  onGoToListClick: PropTypes.func.isRequired,
}

export default memo(Offer)
